import './ContentWrapper.scss';
import * as React from 'react';
import classnames from 'classnames';
type Props = {
  className?: string;
  children: React.ReactNode;
};
export default class ContentWrapper extends React.Component<Props> {
  render() {
    return (
      <div className={classnames('ContentWrapper', this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}
